import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/wcandillon/tmp/tmp/react-native-redash/packages/docs/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "run-animations"
    }}>{`Run Animations`}</h1>
    <hr></hr>
    <h2 {...{
      "id": "timing"
    }}><inlineCode parentName="h2">{`timing()`}</inlineCode></h2>
    <pre><code parentName="pre" {...{
        "className": "language-tsx"
      }}>{`interface TimingParams {
    clock?: Animated.Clock;
    from?: Animated.Adaptable<number>;
    to?: Animated.Adaptable<number>;
    duration?: Animated.Adaptable<number>;
    easing?: Animated.EasingFunction;
}
const timing: (params: TimingParams) => Animated.Node<number>;
`}</code></pre>
    <p>{`Convenience function to run a timing animation.
Example usage:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-tsx"
      }}>{`timing({
  duration: 10 * 1000,
  from: 0,
  to: 1,
  easing: Easing.linear,
});
`}</code></pre>
    <hr></hr>
    <h2 {...{
      "id": "decay"
    }}><inlineCode parentName="h2">{`decay()`}</inlineCode></h2>
    <pre><code parentName="pre" {...{
        "className": "language-tsx"
      }}>{`export interface DecayParams {
    clock?: Animated.Clock;
    from?: Animated.Adaptable<number>;
    velocity?: Animated.Value<number>;
    deceleration?: Animated.Adaptable<number>;
}
const decay: (params: DecayParams) => Animated.Node<number>;
`}</code></pre>
    <p>{`Convenience function to run a decay animation.`}</p>
    <h2 {...{
      "id": "spring"
    }}><inlineCode parentName="h2">{`spring()`}</inlineCode></h2>
    <pre><code parentName="pre" {...{
        "className": "language-tsx"
      }}>{`interface SpringParams {
    clock?: Animated.Clock;
    from?: Animated.Adaptable<number>;
    to: Animated.Adaptable<number>;
    velocity?: Animated.Value<number>;
    config?: SpringConfig;
}
const spring: (params: SpringParams) => Animated.Node<number>;
`}</code></pre>
    <p>{`Convenience function to run a spring animation.`}</p>
    <h2 {...{
      "id": "delay"
    }}><inlineCode parentName="h2">{`delay()`}</inlineCode></h2>
    <pre><code parentName="pre" {...{
        "className": "language-tsx"
      }}>{`const delay: (node: Animated.Node<number>, duration: number) => Animated.Node<number>;
`}</code></pre>
    <p>{`Evaluate an animation node after a certain amount of time. `}<inlineCode parentName="p">{`duration`}</inlineCode>{` is in milliseconds.
Example usage:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`delay(set(value, 1), 250);
`}</code></pre>
    <h2 {...{
      "id": "loop"
    }}><inlineCode parentName="h2">{`loop()`}</inlineCode></h2>
    <pre><code parentName="pre" {...{
        "className": "language-tsx"
      }}>{`interface LoopProps {
    clock?: Animated.Clock;
    easing?: Animated.EasingFunction;
    duration?: number;
    boomerang?: boolean;
    autoStart?: boolean;
}
const loop: (loopConfig: LoopProps) => Animated.Node<number>;
`}</code></pre>
    <p>{`Returns an animated node that goes from `}<inlineCode parentName="p">{`0`}</inlineCode>{` to `}<inlineCode parentName="p">{`1`}</inlineCode>{` during the time set by `}<inlineCode parentName="p">{`duration`}</inlineCode>{` continuously. If the `}<inlineCode parentName="p">{`boomerang`}</inlineCode>{` option is set to `}<inlineCode parentName="p">{`true`}</inlineCode>{`, the animation goes from `}<inlineCode parentName="p">{`0`}</inlineCode>{` to `}<inlineCode parentName="p">{`1`}</inlineCode>{` and then from `}<inlineCode parentName="p">{`1`}</inlineCode>{` to `}<inlineCode parentName="p">{`0`}</inlineCode>{` in the next cycle.
Example usage:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-tsx"
      }}>{`const progress = new Value(0);
set(progress, loop({ duration: 400, easing: Easing.linear }));
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      